import React, { useState } from "react";
import { AuthLayout } from "../components";
import SignUp from './signup';

function AuthPage(props) {
    const [isOtp, setIsOtp] = useState(false)
    const [isOtpSend, setIsOtpSend] = useState(false)


    return (
        <AuthLayout top="0.1rem" width="100%"
            url={
                isOtp
                    ? "/media/signup/optfooter.png"
                    : (isOtpSend
                        ? "/media/login/login_footer.png"
                        : "/media/login/login_footer.png"  
                    )
            }>
            <SignUp tier={props?.tier} setIsOtp={setIsOtp}  isOtpSend={isOtpSend}  setIsOtpSend={setIsOtpSend}/>
        </AuthLayout>
    );
}

export default AuthPage;